import { getCookie } from 'lib/cookies';
import axiosInstance from 'configs/axiosConfig';

const config = () => {
  return {
    headers: {
      'Authorization': `Bearer ${getCookie('access')}`,
      'Set-Cookie': getCookie('refresh'),
    },
  };
};

export function getAllReservations() {
  return axiosInstance.get(`${process.env.REACT_APP_URI}${process.env.REACT_APP_BOARD_RESERVATION_API}`, config());
}

export function updateReservationById(dataToSubmit) {
  return axiosInstance.patch(`${process.env.REACT_APP_URI}${process.env.REACT_APP_BOARD_RESERVATION_API}`, dataToSubmit, config());
}

export function getFiveReservations() {
  return axiosInstance.get(`${process.env.REACT_APP_URI}${process.env.REACT_APP_BOARD_RESERVATION_API}/dashboard`, config());
}
